import { useTranslation } from 'react-i18next';

import { Search, X } from 'lucide-react';

interface DashboardSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

/** The search field next to a dashboard section's title (Projects, Drawings); full width on a phone. */
export function DashboardSearch({ value, onChange, placeholder }: DashboardSearchProps) {
  const { t } = useTranslation();
  return (
    <label className="flex items-center gap-2 h-9 w-full sm:w-64 rounded-lg bg-[#111111] border border-white/15 px-3 transition-colors focus-within:border-lime-400/60">
      <Search className="w-4 h-4 shrink-0 text-white/60" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
        className="flex-1 min-w-0 bg-transparent text-sm text-white outline-none placeholder:text-white/40"
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label={t('common.clearSearch')}
          className="text-white/50 hover:text-white"
        >
          <X className="w-4 h-4" />
        </button>
      )}
    </label>
  );
}
